module.exports = __webpack_public_path__ + "static/media/security-pass.89e02bb0.jpg";